import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=647a1e70&scoped=true&"
import script from "./SectionContainer.vue?vue&type=script&lang=js&"
export * from "./SectionContainer.vue?vue&type=script&lang=js&"
import style0 from "./SectionContainer.vue?vue&type=style&index=0&id=647a1e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a1e70",
  null
  
)

export default component.exports